class Product extends BaseElement
{
  init ()
  {
    this.initGallery();
  }

  initGallery ()
  {
    document.querySelectorAll('.product-tab-gallery').forEach(gallery => {
      Fancybox.bind(gallery.querySelector('.product-tab-gallery-thumbs'), {
        keyboard: true,
        buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'share', 'close']
      });
    });
  }
}

if (!customElements.get('product-main')) {
  customElements.define('product-main', Product);
}